export default __webpack_public_path__ + "static/media/rendflesh.9b3d177b.png";